// extracted by mini-css-extract-plugin
export default {"statsContainer":"stats_statsContainer__4Dnh7"};